export const ACTIONS = {
  HANDLE_SUCCESS_GET_BIKE_BUDDY: 'handleSuccessGetBikeBuddy',
  FETCHING_BIKE_BUDDY: 'fetchingBikeBuddy',
};
